import { Navigate, useRoutes } from 'react-router-dom';
import { lazy } from 'react';
import { useAppSelector } from '../redux/hooks';

const Login = lazy(() => import('../views/login/Login'));
const Dashboard = lazy(() => import('../views/dashboard/Dashboard'));
const Analyze = lazy(() => import('../views/analyze/Analyze'));
const Info = lazy(() => import('../views/info/Info'));
const Notification = lazy(() => import('../views/notification/Notification'));
const RoomRundown = lazy(() => import('../views/room/RoomRundown'));
const RoomInfo = lazy(() => import('../views/room/RoomInfo'));
const RoomGraph = lazy(() => import('../views/room/RoomGraph'));
const Tenancy = lazy(() => import('../views/tenancy/Tenancy'));
const Report = lazy(() => import('../views/report/Report'));

function AppRoutes() {
	const loggedIn = useAppSelector((state) => state.authentication.loggedIn);
	const tenancyStatus = useAppSelector((state) => state.authentication.tenancyStatus);

	return useRoutes([
		{
			path: '/login',
			element: loggedIn ? (
				tenancyStatus ? (
					<Navigate replace to="/dashboard" />
				) : (
					<Navigate replace to="/tenancy" />
				)
			) : (
				<Login />
			),
		},
		{
			path: '/tenancy',
			element: loggedIn ? (
				!tenancyStatus ? (
					<Tenancy />
				) : (
					<Navigate replace to="/dashboard" />
				)
			) : (
				<Navigate replace to="/login" />
			),
		},
		{
			path: '/analyze',
			element: loggedIn ? (
				tenancyStatus ? (
					<Analyze />
				) : (
					<Navigate replace to="/tenancy" />
				)
			) : (
				<Navigate replace to="/login" />
			),
		},
		{
			path: '/dashboard',
			element: loggedIn ? (
				tenancyStatus ? (
					<Dashboard />
				) : (
					<Navigate replace to="/tenancy" />
				)
			) : (
				<Navigate replace to="/login" />
			),
		},
		{
			path: '/room',
			element: loggedIn ? (
				tenancyStatus ? (
					<RoomRundown />
				) : (
					<Navigate replace to="/tenancy" />
				)
			) : (
				<Navigate replace to="/login" />
			),
			children: [
				{
					path: ':roomId',
					index: true,
					element: loggedIn ? (
						tenancyStatus ? (
							<RoomInfo />
						) : (
							<Navigate replace to="/tenancy" />
						)
					) : (
						<Navigate replace to="/login" />
					),
				},
				{
					path: ':roomId/graph',
					element: loggedIn ? (
						tenancyStatus ? (
							<RoomGraph />
						) : (
							<Navigate replace to="/tenancy" />
						)
					) : (
						<Navigate replace to="/login" />
					),
				},
			],
		},
		{
			path: '/info',
			element: loggedIn ? (
				tenancyStatus ? (
					<Info />
				) : (
					<Navigate replace to="/tenancy" />
				)
			) : (
				<Navigate replace to="/login" />
			),
		},
		{
			path: '/notification',
			element: loggedIn ? (
				tenancyStatus ? (
					<Notification />
				) : (
					<Navigate replace to="/tenancy" />
				)
			) : (
				<Navigate replace to="/login" />
			),
		},
		{
			path: '/report',
			element: loggedIn ? (
				tenancyStatus ? (
					<Report />
				) : (
					<Navigate replace to="/tenancy" />
				)
			) : (
				<Navigate replace to="/login" />
			),
		},
		{ path: '*', element: <Navigate to="/dashboard" replace /> },
	]);
}

export default AppRoutes;
